import { useCallback } from "react";
import { downloadJSON, DownloadJSONOptions } from "../utils/downloadJson";

/**
 * Custom hook for downloading JSON data
 * Provides a memoized download function to prevent unnecessary re-renders
 * 
 * @example
 * const { download } = useDownloadJson();
 * download({ data: myData, filename: "export.json" });
 */
export const useDownloadJson = () => {
  const download = useCallback((options: DownloadJSONOptions) => {
    downloadJSON(options);
  }, []);

  return { download };
};
